import { AxiosResponse, Canceler } from 'axios';
import { ITheme, ILabeledThemes } from '../types';
import settings from '../settings';
import api from './base';

export function fetchLabeledThemes(): [Promise<AxiosResponse<ILabeledThemes[]>>, Canceler] {
  const uri = `${settings.getApiURI()}/theme/v1/themes`;

  return api.getWithCancel(uri);
}

export function updatePopularThemes(themes: ITheme[]): Promise<AxiosResponse<ITheme[]>> {
  const uri = `${settings.getApiURI()}/theme/v1/popular`;

  return api.http.patch(uri, themes);
}

export function updateTheme(theme: ITheme): Promise<AxiosResponse<ITheme>> {
  const uri = `${settings.getApiURI()}/theme/v1/themes/${theme.id}`;

  return api.http.patch(uri, theme);
}
